import React from 'react';
import { Layout } from '../components/common';

const BinManagementDemo = () => {
  return (
    <Layout activeNav="bins" onNavChange={() => {}}>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Bin Management</h1>
        <p className="text-gray-600">Manage warehouse bins and locations.</p>
      </div>

      <div className="bg-white rounded-lg shadow p-8 text-center">
        <p className="text-gray-600 text-lg">Bin Management Content Coming Soon</p>
      </div>
    </Layout>
  );
};

export default BinManagementDemo;
